module.exports = __webpack_public_path__ + "static/media/shapes_26.39558dca.svg";